module.exports = __webpack_public_path__ + "static/media/jardines02.f950b20d.jpg";